// Google Analytics 4 イベントトラッキング
// import { logEvent } from 'firebase/analytics';
// import { analytics } from '../main.js';

// gtagを使用した直接的なイベント送信
const logEvent = (analytics, eventName, parameters) => {
  // gtagが利用可能になるまで待つ
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  } else {
    // gtagがまだ読み込まれていない場合は、少し待ってから再試行
    setTimeout(() => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, parameters);
      }
    }, 1000);
  }
};

// ページビューの記録
export function trackPageView(pagePath, pageTitle) {
  logEvent(null, 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
    page_location: window.location.href
  });
}

// ダウンロード開始の記録
export function trackDownloadStart(whitepaperCode, whitepaperTitle) {
  logEvent(null, 'download_start', {
    whitepaper_code: whitepaperCode,
    whitepaper_title: whitepaperTitle,
    content_type: 'whitepaper'
  });
}

// ダウンロード完了の記録
export function trackDownloadComplete(whitepaperCode, whitepaperTitle, userType = 'new') {
  logEvent(null, 'download_complete', {
    whitepaper_code: whitepaperCode,
    whitepaper_title: whitepaperTitle,
    content_type: 'whitepaper',
    user_type: userType, // 'new' or 'existing'
    value: 1
  });
  
  // コンバージョンイベント
  logEvent(null, 'generate_lead', {
    currency: 'JPY',
    value: 1000, // リードの価値（調整可能）
    whitepaper_code: whitepaperCode,
    whitepaper_title: whitepaperTitle
  });
}

// フォーム開始の記録
export function trackFormStart(formType = 'download') {
  logEvent(null, 'form_start', {
    form_type: formType,
    form_location: window.location.pathname
  });
}

// フォーム完了の記録
export function trackFormComplete(formType = 'download', memberType = 'new') {
  logEvent(null, 'form_complete', {
    form_type: formType,
    member_type: memberType,
    form_location: window.location.pathname
  });
}

// メール登録の記録
export function trackEmailSignup(source = 'download_form') {
  logEvent(null, 'sign_up', {
    method: 'email',
    source: source
  });
}

// ホワイトペーパー一覧の表示
export function trackWhitepaperListView() {
  logEvent(null, 'view_item_list', {
    item_list_id: 'whitepapers',
    item_list_name: 'ホワイトペーパー一覧'
  });
}

// 個別ホワイトペーパーの詳細表示
export function trackWhitepaperView(whitepaperCode, whitepaperTitle) {
  logEvent(null, 'view_item', {
    currency: 'JPY',
    value: 0,
    items: [{
      item_id: whitepaperCode,
      item_name: whitepaperTitle,
      item_category: 'whitepaper',
      price: 0
    }]
  });
}

// 離脱防止ポップアップの表示
export function trackExitPopupShow(whitepaperCode) {
  logEvent(null, 'exit_popup_show', {
    whitepaper_code: whitepaperCode,
    page_location: window.location.pathname
  });
}

// 離脱防止ポップアップのクリック
export function trackExitPopupClick(action, whitepaperCode) {
  logEvent(null, 'exit_popup_click', {
    action: action, // 'download' or 'close'
    whitepaper_code: whitepaperCode
  });
}

// カスタムエラーの記録
export function trackError(errorType, errorMessage) {
  logEvent(null, 'exception', {
    description: errorMessage,
    fatal: false,
    error_type: errorType
  });
}